export const settings = {
	comp_title: import.meta.env.VITE_APP_THEME === 'light' ? 'Bgaming' : 'WINGO'
};
